import React from "react";
import { Link } from "react-router-dom";
import "./groupdesign/ListofGroup.css";
import DeleteButton  from "../icon/deleteicon";
import { getApiBaseUrl } from "../../config/api";
import {
  canManageGroup,
  formatGroupDeleteAt,
  isGroupDeactivated,
  isGroupPendingDelete,
} from "../../utils/groupRole";

export default function ListofGroup({
  myGroups = [],
  publicGroups = [],
  selectedTab,
  isAdmin = false,
  user = null,
  deleteGroup,
}) {
  const API_URL = getApiBaseUrl();
  const buildPhotoUrl = (photo) => {
    const fallback = "https://fms.techtreeglobal.com/assets/uploads/1743233100_key.png";
    if (!photo) return fallback;

    if (/^https?:\/\//i.test(photo)) return photo;

    const base = API_URL.replace(/\/+$/, "");
    if (photo.startsWith("/")) return `${base}${photo}`;
    if (photo.includes("uploads/")) return `${base}/${photo}`;
    return `${base}/uploads/groups/${photo}`;
  };

  const renderGroupCard = (g, isPublic = false) => {
    const groupName = g.name || g.group_name || "Untitled Group";
    const groupDesc = g.description || g.group_description || "No description provided";
    const photoUrl = buildPhotoUrl(g.group_photos);
    const pendingDelete = isGroupPendingDelete(g);
    const deactivated = isGroupDeactivated(g);
    const canManage =
      isAdmin ||
      canManageGroup(user, [{ role: g.my_role, user_id: user?.id, status: "accepted" }], g.created_by);
    const showDelete = isAdmin || (canManage && !pendingDelete);

  return (
      <div key={g.id} className="group-cardlist2-wrapper">
        {showDelete && (
          <button
            className="group-delete-btn"
            title="Delete this group"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              deleteGroup && deleteGroup(g.id);
            }}
          >
            <DeleteButton />
          </button>
        )}

        {/* ✅ Card link */}
        <Link
          to={isPublic ? `/group/public/${g.id}` : `/group/${g.id}`}
          style={{
            textDecoration: "none",
            color: "inherit",
            display: "block",
            width: "100%",
          }}
        >
          <div className="group-cardlist2">
            <div className="card-image">
              <img
                src={photoUrl}
                alt={groupName}
                onError={(e) => {
                  e.currentTarget.src =
                    "https://fms.techtreeglobal.com/assets/uploads/1743233100_key.png";
                }}
              />
            </div>

            <div className="card-content">
              <div>
                <h3 style={{ textAlign: 'center' }}>{groupName}</h3>
                <div style={{ textAlign: 'center' }}>
                  {g.visibility ? (
                    <span
                      style={{
                        display: 'inline-block',
                        margin: '0 4px 6px 0',
                        padding: '2px 8px',
                        borderRadius: 999,
                        fontSize: '0.65rem',
                        fontWeight: 650,
                        textTransform: 'capitalize',
                        background:
                          g.visibility === 'private' ? '#fff3e0' : '#e8f4fa',
                        color: g.visibility === 'private' ? '#e65100' : '#2a6f8c',
                      }}
                    >
                      {g.visibility}
                    </span>
                  ) : null}
                  {pendingDelete ? (
                    <span
                      className="group-status-badge group-status-badge--delete"
                      title={formatGroupDeleteAt(g.scheduled_delete_at)}
                    >
                      Deletes in 3 days
                    </span>
                  ) : deactivated ? (
                    <span className="group-status-badge group-status-badge--off">
                      Deactivated
                    </span>
                  ) : null}
                </div>
                <p style={{ textAlign: 'center' }}>
                  {groupDesc.length > 60
                    ? groupDesc.slice(0, 60) + '...'
                    : groupDesc}
                </p>
              </div>

              <p className="view-group-link">View Group</p>
            </div>
          </div>
        </Link>
      </div>
    );
  };
  if (selectedTab === "my") {
    return myGroups.length === 0 ? (
      <p className="groups-empty">
        You have not joined or created any groups yet. Create one above, or browse Public Groups.
      </p>
    ) : (
      <div className="group-list2">{myGroups.map((g) => renderGroupCard(g))}</div>
    );
  }

  if (selectedTab === "public") {
    return publicGroups.length === 0 ? (
      <p className="groups-empty">No public groups available yet.</p>
    ) : (
      <div className="group-list2">{publicGroups.map((g) => renderGroupCard(g, true))}</div>
    );
  }

  return null;
}
